<script setup lang="ts">
import { PhArrowRight, PhBug } from '@phosphor-icons/vue'
import { BOUNTY_URL } from '@/config/bounty'

defineOptions({ name: 'BountyBanner' })
</script>

<template>
  <!-- A saturated strip that reads the same in both themes, so its text stays literal white. -->
  <aside
    aria-label="Break Our Escrow bounty"
    class="bounty-banner relative z-40 flex-none bg-linear-to-r from-cyan-700 via-blue-700 to-violet-700 text-white"
  >
    <div class="mx-auto flex max-w-5xl items-center justify-center gap-x-3 px-4 py-2 text-[13px] leading-snug sm:text-sm">
      <PhBug class="hidden h-4 w-4 shrink-0 sm:block" weight="fill" aria-hidden="true" />
      <p class="min-w-0">
        <!-- Phones keep it to one line: the name and the button. -->
        <strong class="font-bold">Break Our Escrow</strong> bounty<span class="hidden sm:inline"> is live: help us test on Testnet and earn Mainnet Pi.</span>
      </p>
      <a
        :href="BOUNTY_URL"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex shrink-0 items-center gap-1 rounded-md bg-black/25 px-2.5 py-1 font-semibold transition-colors hover:bg-black/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
      >
        Join the bounty
        <PhArrowRight class="h-3.5 w-3.5" weight="bold" aria-hidden="true" />
      </a>
      <span class="hidden text-white/80 md:inline">Ends Friday 13 November.</span>
    </div>
  </aside>
</template>

<style scoped>
/* Sits above the header, so it takes over the notch inset on phones. */
.bounty-banner {
  padding-top: env(safe-area-inset-top);
}
</style>
